import { render } from "./Claim_2_Reassessment_submittedBill.vue?vue&type=template&id=00ed47ca&ts=true"
import script from "./Claim_2_Reassessment_submittedBill.vue?vue&type=script&lang=ts"
export * from "./Claim_2_Reassessment_submittedBill.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__